import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-4 hidden md:block" }
const _hoisted_2 = { class: "mb-6 text-lg text-gray-700 font-body" }
const _hoisted_3 = {
  key: 0,
  class: "bg-danger text-white text-center rounded-full px-2 h-6 min-w-6"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode("ul", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, int) => {
        return (_openBlock(), _createBlock("li", {
          class: ["flex flex-row items-center justify-between", {
					'text-gray-500 text-sm hover:text-gray-700 hover:bg-gray-100 cursor-pointer px-2 py-2':
						item[_ctx.itemValue] !== _ctx.selectedItem,
					'text-gray-700 text-sm cursor-pointer px-2 py-2 bg-gray-300 rounded':
						item[_ctx.itemValue] === _ctx.selectedItem,
				}],
          key: int,
          onClick: $event => (_ctx.emitSelected(item[_ctx.itemValue]))
        }, [
          _createVNode("span", null, _toDisplayString(item[_ctx.itemLabel]), 1),
          (
						Object.keys(_ctx.notifications).length &&
							_ctx.notifications[item[_ctx.itemValue]]
					)
            ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.notifications[item[_ctx.itemValue]]), 1))
            : _createCommentVNode("", true)
        ], 10, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}